<template>
  <v-form ref="SALARIE_FISCALITE" @submit.prevent="sectionSave" lazy-validation class="section">
    <div>
      <section-header v-if="!hideTitle"
                      :ressource="ressource"
                      :isExtended="extended"
                      :dialog="dialog"
                      :picto="picto()"
                      :fiche=fiche
                      :isAbstract=isAbstract
                      @extended=setExtended
                      @closeDialog=closeDialog
                      ref="SALARIE_FISCALITE">
      </section-header>
      <div v-if="extended" id="field-container" :class="dialog ? 'p-0 p-md-3' : 'py-2'">
        <salarie-fiscalite v-if="isDisplayed('FISCALITE')"
                           ref="FISCALITE"
                           :theme="theme"
                           :showMissing="showMissing"
                           v-model:value=fiscalite
                           @status=statusFiscalite
                           :required="isRequired('FISCALITE')"
                           :contextId=salarie.id
                           :readOnly="readOnly('FISCALITE')"
                           :objType=objType
                           :fiche=fiche
                           :sectionName="sectionName">
        </salarie-fiscalite>
      </div>
    </div>
    <div v-if="extended" class="d-flex flex-row-reverse">
      <loader-button v-if="saveButton"
                     class="ms-2"
                     type="submit"
                     :loading="saveLoading"
                     :label="saveLabel"
                     :disabled="!updatedAndValid">
      </loader-button>
      <div v-for="(button, index) in extraButtons" :key="index">
        <loader-button class="ms-2"
                       :outlined="button.outlined"
                       @callback="button.callback()"
                       :type="button.type"
                       :label="button.label"
                       :loading="button.loading"
                       :disabled="button.disabled">
        </loader-button>
      </div>
    </div>
    <div class="d-flex flex-row-reverse" v-if="saveFailed && saveButton && extended">
      <p class="text-12 text-bold error-text">{{errorTxt}}</p>
    </div>
  </v-form>
</template>

<script lang="ts">
  import { defineComponent } from "vue";
  import CrudSalarie from '@/generated/cruds/CrudSalarie';
  // eslint-disable-next-line
  import { GenControl, GenSection, RessourceGenControl, RessourceGenSection } from '@/generated/ressources/generatedRessources';
  import { FwkButtons, RessourceFwkButton, RessourceFwkSection, FwkSections } from '@/ressources/globalRessources';
  import { Sections } from '@/generated/classes/AppSchema';
  import Button, { ButtonCallback } from '@/framework/base/classes/Button';
  import { ObjTypes } from '@/generated/classes/ObjTypes';

  export default defineComponent({
    extends:  CrudSalarie,
    components: {},
    props: {
      hideTitle: {
        type: Boolean,
      },
      isAbstract: {
        type: Boolean,
      },
    },

    data() {
      return {
        sectionName: Sections.SALARIE_FISCALITE,
        displayMap: new Map<string, Boolean>,
        readOnlyMap: new Map<string, Boolean>,
        requiredMap: new Map<string, Boolean>,
      }
    },

    computed: {
      saveLabel () { 
        return RessourceFwkButton(FwkButtons.ENREGISTRER).label;
      },

      errorTxt () { 
        return RessourceFwkSection(FwkSections.ERROR_TEXT).label;
      },


      ressource () { return RessourceGenSection(GenSection.SALARIE_FISCALITE); },

      fields (): string[] {
        return ['FISCALITE'];
      },

      extraButtons (): Button[] {
        return [];
      },

    },
    methods: {
      getRequiredAttributs(): string[] {
        const res: string[] = [];
        if (this.requiredAttributs) {
          this.requiredAttributs.forEach((attrib) => {
            const value = attrib.split(".");
            if (value[0] == this.sectionName) {
              res.push(value[1])
            }
          })
        }
        return res;
      },

      requiredMissing(requiredAttributs: string[], value: string): boolean {
        return requiredAttributs.length > 0 && requiredAttributs.includes(value);;
      },

      readOnly (value: string): boolean {
        let res = false;
        if (!this.editSalarie.canUpdate) {
          return true;
        }
        if (this.readOnlyMap.size == 0) {
          this.readOnlyMap.set("FISCALITE", false);
        }
        const readOnly = this.readOnlyMap.get(value);
        if (readOnly != undefined) {
          res = readOnly;
        }
        return res;
      },

      isDisplayed (value: string): boolean {
        let res = true;
        if (this.displayMap.size == 0) {
        const requiredAttributs = this.getRequiredAttributs();
          this.displayMap.set("FISCALITE", true);
        }
        const display = this.displayMap.get(value);
        if (display != undefined) {
          res = display;
        }
        return res;
      },

      isRequired (value: string): boolean {
        let res = true;
        const requiredAttributs = this.getRequiredAttributs();
        if (this.requiredMap.size == 0) {
          this.requiredMap.set("FISCALITE", true);
        }
        const required = this.requiredMap.get(value);
        if (required != undefined) {
          res = required;
        }
        return res;
      },

      picto (): string {
        return 'SectionPictoFiscalite' 
      },

      sectionSave (): void {
        return this.save();
      }
    }
  })
</script>
